import { TCommunications, TUserType } from 'contexts/app-context/types'
import { useGetPurposesUs } from 'hooks/useGetPurposesUs'
import { filter } from 'lodash'
import { useParams } from 'react-router-dom'

type TUseMeansOfCommunication = {
  communications: TCommunications<TUserType>
}

export function useMeansOfCommunication({ communications }: TUseMeansOfCommunication) {
  const { productId } = useParams()

  const { purpose, isPurposesLoading, isPurposesError } = useGetPurposesUs(productId)

  return {
    filteredCommunications: filter(communications, (communication) => communication !== undefined),
    purpose,
    isPurposesLoading,
    isPurposesError,
    productId,
  }
}
